import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Alert, Button, Col, Input, Row, Space, Statistic, Table, Modal } from 'antd';
import { UserStore } from '../../../stores/UserStore';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { PaginationComponent } from '../../../components/pagination';
import { ColumnsType } from 'antd/es/table';
import { CategoryProps } from '../../../types/types.ds';
import { Helmet } from 'react-helmet';
import { Loading } from '../../../components/loading/loading';
import { FieldNumberOutlined } from '@ant-design/icons';
import { useQueryParameters } from '../../../hooks/useQueryParameters';
import { Key } from 'antd/lib/table/interface';
import { CategoryAdminStore } from '../../../stores/Admin/CategoryAdminStore';
import CategoryAddForm from '../../../components/categories/CategoryAddForm';
import CategoryFilterForm from './components/CategoryFilterForm';

const { Search } = Input;

const CategoryList = observer(() => {
    const history = useHistory();
    const parameters = useQueryParameters();
    const location = useLocation();
    const [selectedRowsKeys, setSelectedRowsKeys] = useState<Key[]>([]);

    const [showAddCategory, setShowAddCategory] = useState(false);

    const handleGetData = (values: { search: string; owner: string }) => {
        CategoryAdminStore.getCategories(values);
    };

    useEffect(() => {
        const params: any = {};

        if (parameters.get('search')) {
            params['search'] = parameters.get('search');
        }

        if (parameters.get('is_promotion')) {
            params['is_promotion'] = parameters.get('is_promotion');
        }

        if (parameters.get('owner')) {
            params['owner'] = parameters.get('owner');
        }

        // Not Staff User get only its own products
        params['owner'] = UserStore.user?.uid;

        handleGetData(params);
    }, [location.search]);

    const columns: ColumnsType<CategoryProps> = [
        {
            title: 'Nombre',
            dataIndex: 'name',
            key: 'name',
            render: text => <div>{text}</div>,
        },
        {
            title: 'Padre',
            dataIndex: 'parent_related__name',
            key: 'parent_related__name',
            render: (text, r) => <div>{r.parent_related?.name}</div>,
        },
        {
            title: 'Orden',
            dataIndex: 'order',
            key: 'order',
            render: (text, r) => <div>{r.order}</div>,
        },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => (
                <Space size="middle">
                    <Link to={`/admin/categories/${record.uid}/edit`}>Modificar</Link>
                </Space>
            ),
        },
    ];

    if (!UserStore.user?.uid) {
        return (
            <div>
                <Loading />
            </div>
        );
    }

    return (
        <React.Fragment>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Gestionar Categorias</title>
            </Helmet>
            <section className="mt-4">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            {UserStore.user.is_seller && !UserStore.user.published && (
                                <div className={'my-4'}>
                                    <Alert
                                        message="El establemiento no esta publicado todavía, comunicate con un representante de rush delivery para ayudarte"
                                        type="warning"
                                    />
                                </div>
                            )}

                            <Button
                                className="rounded"
                                type="primary"
                                onClick={() => {
                                    setShowAddCategory(true);
                                }}
                            >
                                Nueva Categoria
                            </Button>

                            <div className={'my-6'}>{<CategoryFilterForm />}</div>

                            {showAddCategory && (
                                <Modal
                                    bodyStyle={{ height: 500, width: '100%' }}
                                    title="Nueva Categoria"
                                    visible={true}
                                    onCancel={() => setShowAddCategory(false)}
                                    footer={[]}
                                >
                                    <CategoryAddForm
                                        handleSave={payload => {
                                            CategoryAdminStore.create(payload);
                                            setShowAddCategory(false);
                                        }}
                                    />
                                </Modal>
                            )}
                            <div className={'my-4'}>
                                <Table
                                    rowSelection={{
                                        selectedRowKeys: selectedRowsKeys,
                                        onChange: selectedRows => {
                                            setSelectedRowsKeys(selectedRows);
                                        },
                                    }}
                                    pagination={false}
                                    columns={columns}
                                    loading={CategoryAdminStore.loading}
                                    dataSource={CategoryAdminStore.categories}
                                    footer={() => {
                                        return (
                                            <PaginationComponent
                                                pageSize={100}
                                                total={CategoryAdminStore.total_records}
                                            />
                                        );
                                    }}
                                />
                            </div>
                            <div className={'p-4 text-center'}>
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <Statistic
                                            title="#"
                                            value={CategoryAdminStore.total_records}
                                            prefix={<FieldNumberOutlined />}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
});

export default CategoryList;
